import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import PrimaryButtonPageLevel from "../../components/button/primary-button/PrimaryButtonLevelPage";
import PrimaryButtonLevelSection from "../../components/button/primary-button/PrimaryButtonLevelSection";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import ImageFromUrl from "../../components/parseImage/ImageFromUrl";
import ConstantStrings from "../../constants/ConstantStrings";
import { getRoadMap } from "../../reducers/roadmapSlice";
import { checkAndGetAnonymousUserId } from "../../templates/helper/CheckAndGetAnonymousUserId";
import { checkIsVn, getConstantStringByLanguage } from "../../templates/helper/getConstantStringByLanguage";
import PopupCloseButton from "../../components/button/special-button/PopupCloseButton";

const PracticeIKMC = ({ gradeId, gradeName }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const token = cookies.get("signinUser") || cookies.get("register");

  const [showPopup,setShowPopup] = useState(false)

  const handleClickRoadMap = async () => {
    if (checkIsVn()) {
      localStorage.removeItem("takeRoadMapExamId");
      localStorage.removeItem("takeRoadMapProblemSetId");
      localStorage.removeItem("submittedProblemSet");
      localStorage.removeItem("submitted");
      dispatch(
        getRoadMap({
          gradeId: cookies.get("gradeId"),
          isAnonymous: token ? false : true,
          anonymousUserId: checkAndGetAnonymousUserId(),
          categoryId: ConstantStrings.IKMC_ID,
        })
      );
      navigate("/roadmap-exam");
    } else {
      setShowPopup(true)
    }
  };

  const removePopup = () => {
    setShowPopup(false)
  }
  return (
    <div className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center is-relative">
      {showPopup && <div
        className="modal is-active is-justify-content-center"
        style={{ zIndex: 1000 }}
      >
        <div className=" modal-background" style={{ opacity: "0.8" }}></div>
        <div
          className="has-background-kurio-main-color-white is-relative is-flex is-flex-direction-column is-align-items-center"
          style={{
            borderRadius: "2rem",
            height: "auto",
            maxHeight: "84.7%",
            width: "auto",
            padding: "4rem",
          }}
        >
          <div
            className="is-flex is-flex-direction-column is-align-items-center select-service pr-2"
            style={{ overflowY: "auto", gap: "2.5rem" }}
          >
            <p className="is-uppercase is-size-1 has-text-kurio-main-color-black has-text-weight-bold">
              {getConstantStringByLanguage(ConstantStrings.COMING_SOON)}
            </p>
            <PrimaryButtonPageLevel onClick={removePopup}>
              {getConstantStringByLanguage(ConstantStrings.CLOSE)}
            </PrimaryButtonPageLevel>
          </div>

          <div
            onClick={removePopup}
            className=""
            style={{
              position: "absolute",
              top: "-8%",
              left: "-4%",
              zIndex: 9999,
              background: "transparent",
              border: "none",
              width: "5rem",
              fontSize: "2rem",
            }}
          >
            <PopupCloseButton />
          </div>
        </div>
      </div>}
      <div className="is-flex is-flex-direction-column is-align-items-center is-flex-gap-5 has-text-kurio-main-color-white">
        <p
          className="has-text-weight-bold"
          style={{
            fontSize: "2rem",
            lineHeight: "normal",
            fontStyle: "normal",
          }}
        >
          {getConstantStringByLanguage(ConstantStrings.IKMC_EXAM)}
        </p>
        <BackgroundImageFromUrl
          className="is-flex is-align-items-center is-align-self-stretch is-justify-content-center has-text-kurio-main-color-white"
          objectId={
            "admin/frontend-images/exam-preparation/background-exam-preparation.svg"
          }
          style={{
            borderRadius: "1rem",
            border: "0.09375rem solid #0A2A66",
            boxShadow: "0.125rem 0.25rem 0rem 0rem #0A2A66",
            gap: "0.625rem",
            width: "52rem",
            height: "13.5rem",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div
            className="is-flex is-align-items-center is-justify-content-center"
            style={{ width: "100%", gap: "2rem" }}
          >
            <ImageFromUrl
              style={{ width: "10.66763rem", height: "10rem" }}
              objectId="admin/frontend-images/road-map/exam-preparation-image.png"
              alt=""
            />
            <div className={`is-flex is-flex-direction-column has-text-weight-bold is-align-items-flex-start ${checkIsVn()?"":"is-flex-direction-column-reverse"}`} style={{
              width: "15.88463rem",
              height: "6.832rem",
            }}>
              <p className="is-uppercase" style={{fontSize:"1.5rem",lineHeight:"normal",marginTop:checkIsVn()?"":"-0.5rem"}}>{getConstantStringByLanguage(ConstantStrings.STUDY_ROADMAP)}</p>
              <p style={{fontSize:"5rem",lineHeight:"normal",marginTop:checkIsVn()?"-0.75rem":""}}>IKMC</p>
            </div>
            {/* <img
              style={{
                width: "15.88463rem",
                height: "6.832rem",
                objectFit: "cover",
              }}
              src="/images/exam-preparation/text_ikmc.svg"
              alt=""
            /> */}

            <div
              className="is-flex is-flex-direction-column is-flex-gap-4 is-justify-content-center is-align-items-flex-start"
              style={{
                fontSize: "1rem",
                lineHeight: "normal",
                height: "8.75rem",
                width: "13.9375rem",
              }}
            >
              <p>
                {ConstantStrings.HIDE_GRADES.includes(gradeName)
                  ? getConstantStringByLanguage(ConstantStrings.IKMC_LEARNING_PATH_DESCRIPTION)
                  : getConstantStringByLanguage(ConstantStrings.IKMC_PREP_EASY_DESCRIPTION)}
              </p>
              <PrimaryButtonPageLevel
                isDarkColor={true}
                onClick={handleClickRoadMap}
                style={{
                  height: "4rem",
                  width: "12.5rem",
                  maxWidth: "12.5rem",
                  borderRadius: "1rem",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.TRY_NOW)}
              </PrimaryButtonPageLevel>
            </div>
          </div>
        </BackgroundImageFromUrl>
        <div className=" is-flex is-flex-gap-6 is-align-items-flex-start is-justify-content-center">
          <BackgroundImageFromUrl
            objectId={
              "admin/frontend-images/practice-ikmc/exam-question-vault-bg.svg"
            }
            className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center has-text-kurio-main-color-black"
            style={{
              border: "0.09375rem solid #0A2A66",
              borderRadius: "1rem",
              width: "25rem",
              height: "15rem",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              boxShadow: "0.125rem 0.25rem 0rem 0rem #0A2A66",
            }}
          >
            <div
              className="is-flex is-flex-direction-column is-flex-gap-4 is-align-items-center is-justify-content-center"
              style={{ width: "20.5rem" }}
            >
              <p
                className="has-text-weight-normal has-text-centered"
                style={{
                  fontSize: "2rem",
                  fontFamily: "Dela Gothic One",
                  fontStyle: "normal",
                  lineHeight: "110%",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.IKMC_EXAM_TITLE)}
              </p>
              <p
                className="has-text-centered"
                style={{
                  fontSize: "1rem",
                  fontStyle: "normal",
                  lineHeight: "normal",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.IKMC_EXAM_DESCRIPTION)}
              </p>
              <PrimaryButtonLevelSection
                onClick={() => navigate("/exams-vault")}
              >
                {getConstantStringByLanguage(ConstantStrings.GO_TO_EXAM_LIBRARY)}
              </PrimaryButtonLevelSection>
            </div>
          </BackgroundImageFromUrl>
          <BackgroundImageFromUrl
            objectId={
              "admin/frontend-images/practice-ikmc/challenge-ikmc-bg.svg"
            }
            className="is-flex is-align-items-center is-justify-content-center has-text-kurio-main-color-white"
            style={{
              border: "0.09375rem solid #0A2A66",
              borderRadius: "1rem",
              width: "25rem",
              height: "15rem",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              boxShadow: "0.125rem 0.25rem 0rem 0rem #0A2A66",
            }}
          >
            <div
              className="is-flex is-flex-direction-column is-flex-gap-4 is-align-items-center is-justify-content-center"
              style={{ width: "20.5rem" }}
            >
              <p
                className="has-text-weight-normal has-text-centered"
                style={{
                  fontSize: "2rem",
                  fontFamily: "Dela Gothic One",
                  fontStyle: "normal",
                  lineHeight: "110%",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.IKMC_CHALLENGE)}
              </p>
              <p
                className="has-text-centered"
                style={{
                  fontSize: "1rem",
                  fontStyle: "normal",
                  lineHeight: "normal",
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.IKMC_CHALLENGE_DESCRIPTION)}
              </p>
              <PrimaryButtonLevelSection
                isDarkColor={true}
                onClick={() => navigate("/challenge-ikmc")}
              >
                {getConstantStringByLanguage(ConstantStrings.START_PRACTICE)}
              </PrimaryButtonLevelSection>
            </div>
          </BackgroundImageFromUrl>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    gradeId: state.grades.gradeId,
    gradeName: state.grades.gradeName,
  };
}

export default connect(mapStateToProps)(PracticeIKMC);
